module.exports = __webpack_public_path__ + "static/media/Wednesday.8896c208.webp";